import { useTheme } from "@emotion/react";
import { Tooltip } from "@mui/material";
import React from "react";
import { useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { setReservationClientVoucherVisibility, setReservationOverviewVisibility } from "src/store/reservations/slices/hotels/HotelDetailSlice";

const VoucherNumberCell = ({ voucherId, voucherNo }) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const { id } = useParams();

    const handleClick = () => {
        dispatch(setReservationOverviewVisibility(false));
        dispatch(setReservationClientVoucherVisibility(true));
    };

    return (
        <Tooltip title={`View Voucher ${voucherNo}`}>
            <Link
                to={`/reservations/${id}/client-voucher/${voucherId}`}
                onClick={handleClick}
                style={{ color: theme.palette.text.info }}
                variant="body2"

            >
                {voucherNo}
            </Link>
        </Tooltip>
    );
};

export default VoucherNumberCell;
